import { useState } from "react";
import { ArrowsOutSimpleIcon } from "@phosphor-icons/react";

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@atoms/new/modal";
import Button from "@atoms/new/button";
import Checkbox from "@atoms/new/checkbox";

interface ResizeHintProps {
  isOpen: boolean;
  onDismiss: (dontShowAgain: boolean) => void;
}

const ResizeHint: React.FC<ResizeHintProps> = ({ isOpen, onDismiss }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onDismiss(dontShowAgain)}
      size="lg"
      hideCloseButton
    >
      <ModalContent>
        <ModalHeader>Resize the Add-In to fit your slide correctly</ModalHeader>
        <ModalBody>
          <p className="text-sm text-default-600 mb-4">
            Drag any corner to resize. Make it slightly smaller than your
            PowerPoint slide.
            <br />
            Leave space in the bottom-left where PowerPoint's navigation
            controls show up in Slide Show view.
          </p>

          <div className="relative border-2 border-dashed border-default-300 rounded">
            <img
              src="/images/onboarding/ppt-resize-hint-preview.png"
              alt=""
              aria-hidden="true"
              className="w-full h-auto rounded-[1px]"
            />

            <ArrowsOutSimpleIcon
              size={24}
              className="absolute bottom-0 left-0 -translate-x-1/2 translate-y-1/2 text-default-500 bg-content2 rounded-full p-1 shadow"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="w-full flex items-center justify-between">
            <Checkbox
              isSelected={dontShowAgain}
              onChange={(e: any) => setDontShowAgain(e.target.checked)}
            >
              <span className="text-sm text-default-600">
                Don't show this again
              </span>
            </Checkbox>

            <Button kind="primary" onPress={() => onDismiss(dontShowAgain)}>
              Got it
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ResizeHint;
